// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","textDefault":"#808080","primary":"#56CCF2","primaryLight":"#ABEAFF","container":"vPLbaZhU65k_Obu4ckjgu","description":"_33nZE8_CQaWwQMu6QtOLyX","tableWrapper":"_2Bkny5d5RY_ONdUHK-cjzw","table":"_3R7mQctmhJmeeXdz7C32lm","tableHeader":"_2vDYPTX4_CX0TbQQl6qEDI","contentHeading":"_3NF9huvXX4ISjGlr7xi-ot","content":"_2AKn2FBbYov8zSu2huQFUS","transaction":"_3YwtG4BsS5MmehC7dWFDLL","transactionTitle":"_3naB7GDkwMSb2jmVM6E_Xu","transactionDescription":"_1Lrr8BEpRDVNQHe5M5uhI7"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Billing/components/BankStatement.mod.css
// module id = 1053
// module chunks = 0